/**
 * @file   密码修改
 * @create macaiqi 2021/12/03
 * @update
 */
import React from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input, Button, message } from 'antd';
import { apiChangePassward } from '../../../shared/api';
import { openLoginModal, logout, } from '../../common/LoginModal/store';


const ChangePassword = () => {
  const dispatch = useDispatch();
  // 登出
  const handleLogOut = () => {
    dispatch(logout());
    dispatch(openLoginModal());
  };
  // 修改
  const handleChange = (value) => {
    console.log(value)
    apiChangePassward({
      newPassword: value.newPassword,
      oldPassword: value.oldPassword,
    }).then(res => {
      if (res.code === 5108) {
        message.error(res.msg)
      } else if (res === true) {
        message.success('修改密码成功,请重新登录');
        handleLogOut();
      } else {
        message.error('修改失败');
      }
    })

  }
  return (
    <div className="personal-common">
      <div className="p-title">修改密码</div>
      <div className="changepassword">
        <Form
          className="changep-form"
          onFinish={(value) => {
            handleChange(value)
          }}
        // initialValues={{
        //   telNum: telNum,
        //   newpassword: '',
        //   confirm: '',
        // }}
        // onValuesChange={(val) => {
        //   if (val?.authCode) {
        //     setAuthCode(val?.authCode);
        //   }
        //   if (val?.newpassword) {
        //     setPassword(val?.newpassword);
        //   }
        // }}
        >
          <Form.Item
            label="原始密码"
            rules={[
              { required: true, message: '请输入原始密码' },
              {
                pattern: /^[a-zA-Z0-9_]{6,18}$/,
                message: '请输入6-18位字母、数字组合'
              }
            ]}
            name="oldPassword"
          >
            <Input.Password placeholder="请输入原始密码" block="true" size="large" />
          </Form.Item>
          <Form.Item
            label="新密码"
            rules={[
              { required: true, message: '请输入新密码' },
              {
                pattern: /^[a-zA-Z0-9_]{6,18}$/,
                message: '请输入6-18位字母、数字组合'
              }
            ]}
            name="newPassword"
          >
            <Input.Password placeholder="新密码(6-18位字母、数字组合)" block="true" size="large" />
          </Form.Item>
          <Form.Item
            label="确认密码"
            name="confirm"
            dependencies={['newPassword']}
            hasFeedback
            rules={[
              {
                required: true,
                message: '请再次输入新密码',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次密码不匹配'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="新密码(6-18位字母、数字组合)" block="true" size="large" />
          </Form.Item>


          <Button
            className="button"
            // type="primary"
            block="true"
            size="large"
            htmlType="submit"
          // disabled={disabled}
          >
            保存
          </Button>
        </Form>
      </div>
    </div>
  )
}

export default ChangePassword;
